import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDatadogComponent } from './simple-icons-datadog.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDatadogComponent ],
    exports:      [ SimpleIconsDatadogComponent ],
    bootstrap:    []
})
export class SimpleIconsDatadogModule {}
